import React from 'react';
import block from 'bem-cn-lite';
import Status from '../Status'
import BlinkingMarker from '../../../Components/BlinkingMarker'

import { TransitionGroup } from 'react-transition-group';
import { FadeTransition } from '../../../Components/Transitions';

class StatusesGroup extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isMenuVisible: false
        }

        this.onStatusSelect = this.onStatusSelect.bind(this)
        this.showMenu = this.showMenu.bind(this)
        this.hideMenu = this.hideMenu.bind(this)

    }

    onStatusSelect(statusId) {
        this.props.onStatusSelect(statusId)
    }

    showMenu() {
        this.setState({
            isMenuVisible: true
        })
    }

    hideMenu() {
        this.setState({
            isMenuVisible: false
        })
    }

    render() {
        const b = block('StatusesGroup');
        const { name } = this.props.group
        
        const menu = (
            <ul className={b('list')}>
                {this.props.statusesList.map(status =>
                    <li className={b('item')} key={status.id}>
                        {(this.props.showCompleteTooltip && status.isComplete) && <BlinkingMarker left={150} top={8} />}
                        <Status status={status} current={this.props.currentStatus} onStatusClick={this.onStatusSelect} /> 
                    </li>
                )}
            </ul>
        )

        return (
            <div className={b({ active: this.props.isActive })} onMouseOver={this.showMenu} onMouseLeave={this.hideMenu}>
                <h4 className={b('title')}>
                    {name}
                    {this.props.showTooltip && <BlinkingMarker left={150} top={8} />}
                </h4>

                {this.props.isActive ? (
                    menu
                ) : (
                    <TransitionGroup
                        component="div"
                    >
                        {this.state.isMenuVisible && <FadeTransition>{menu}</FadeTransition>}
                    </TransitionGroup>
                )}



            </div>
        )
    }
}

export default StatusesGroup